import { Card } from "@components/cards/card";
import { IRaffleDefaultTicketDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { IRaffleTicketFilter } from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { formatName } from "@hooks/functions/formatName";
import { Masks } from "@hooks/functions/Masks/Masks";

interface IProps {
  tickets: IRaffleDefaultTicketDTO[];
  filter: IRaffleTicketFilter;
  ticketsForRow: number;
  ticketsAmount?: number;
  atSign?: string;
}

export function MyRaffleDefaultNumberTickets({
  tickets,
  filter,
  ticketsForRow,
  ticketsAmount,
  atSign,
}: IProps) {
  // Default Variables
  const masks = new Masks();

  const filteredTickets = tickets.filter((item) => {
    if (filter === "e") return true;
    if (filter === "a") return !item?.clientData?.atSign;
    if (filter === "m")
      return atSign ? item?.clientData?.atSign === atSign : false;
    if (filter === "u") return item?.clientData?.atSign;
    return true;
  });

  const ticketRows = filteredTickets.reduce<IRaffleDefaultTicketDTO[][]>(
    (rows, ticket, index) => {
      const rowIndex = Math.floor(index / ticketsForRow);
      if (!rows[rowIndex]) rows[rowIndex] = [];
      rows[rowIndex].push(ticket);
      return rows;
    },
    [],
  );

  return (
    <>
      {ticketRows.map((ticketRow, rowIndex) => (
        <div className="col-12 px-0" key={`ticket-row-${rowIndex}`}>
          <div className="row">
            {ticketRow.map((item, index) => (
              <div
                key={`${rowIndex}-${index}`}
                className="col-12 col-sm-6 col-md mb-3"
              >
              <Card className={`h-100 ${index}`}>
                <div className="card-header pb-0">
                  <div className="d-flex justify-content-center">
                    <span className="h3 fw-bold">{`${
                      Number(item?.ticket) < 10 ? `0` : ``
                    }${masks.formatMilhar(Number(item?.ticket))}`}</span>
                  </div>
                </div>
                <div
                  className="card-body d-flex"
                  style={{ minHeight: "100px" }}
                >
                  <div className="d-flex flex-column flex-md-row justify-content-center gap-2 w-100">
                    {item?.clientData?.atSign ? (
                      <>
                        <div className="d-flex flex-column">
                          <span className="h5">{`@${item?.clientData?.atSign}`}</span>
                          <span className="h6">{`${formatName(item?.clientData?.name || "")}`}</span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="d-flex align-items-center">
                          <span className="h6">
                            <span
                              className={`rounded-circle d-inline-block me-2 bg-success`}
                              style={{ width: 10, height: 10 }}
                              title={`Ticket Disponível`}
                            ></span>
                            Disponível
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Card>
            </div>
            ))}
            {Array.from({
              length: Math.max(0, ticketsForRow - ticketRow.length),
            }).map((_, placeholderIndex) => (
              <div
                key={"ticket-placeholder-" + rowIndex + "-" + placeholderIndex}
                className="d-none d-md-block col-md mb-3"
                aria-hidden="true"
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
